import React from 'react';
import { createTreatmentKey } from 'libs/end-to-end/src/treatment';
import { Treatment } from 'libs/end-to-end/src/treatment';
import { TreatmentCard } from 'apps/sigma2-ui/src/components/TreatmentCard';

export const TreatmentRow: React.FC<{
  treatments: Treatment[];
  disabled: boolean;
  title: React.ReactNode;
  description?: React.ReactNode;
  toggleTreatment: (treatment: Treatment) => void;
}> = ({ title, treatments, toggleTreatment, disabled, description }) => {
  if (treatments.length === 0) {
    return null;
  }

  return (
    <div className="space-y-5">
      <div className="space-y-1">
        {title}

        {description}
      </div>

      <div className="flex gap-x-4">
        {treatments.map((treatment) => {
          const treatmentKey = createTreatmentKey(treatment);

          return (
            <TreatmentCard
              key={treatmentKey}
              treatment={treatment}
              onSelect={() => {
                toggleTreatment(treatment);
              }}
              disabled={disabled}
            />
          );
        })}
      </div>
    </div>
  );
};
